import { EntityType,EntityInstance} from "./Entities";

export class EntitiesListScreenData {

    availableFilters: Object;
    filters: Array<Object>;
    types: EntityType[];
    selectedType: EntityType;
    instances: EntityInstance[];
    selectedItems: Array<Object>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    serverTotalItems: number;
    sort_by: string;
    limit: number;
    offset: number;
    delete_pop_up: boolean;
    download_pop_up: boolean;
    loadingDelete: boolean;
    loadingDownload: boolean;
    //snackbar: Object;
    constructor(){
        this.availableFilters = {
            downloaded: {
                'name': 'downloaded',
                'label': 'Descargados',
                'user_values': [
                    { value: true, text: 'Sí'},
                    { value: false, text: 'No'},
                ],
                'multiple': false,
                'value': '',
                'type': 'select',
                'icon': 'mdi-download-box',
                'text':''
            },
        },
        this.filters = []
        this.types = []
        this.selectedType = null
        this.instances = []
        this.selectedItems = []
        this.loadingItems = false
        this.footerItemsPerPageText = "Items por página"
        this.footerItemsPerPageOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50]
        this.showSelect = false
        this.textNoResults = "No se encontraron resultados"
        this.textLoading = "Cargando..."
        this.itemKey = "uuid"
        this.serverTotalItems = 0
        this.sort_by = ""
        this.limit = 10
        this.offset = 0
        //this.snackbar = {}
        this.delete_pop_up = false
        this.download_pop_up = false
        this.loadingDelete = false
        this.loadingDownload = false
    }


}